import { FC, ReactNode } from 'react';

import classnames from 'classnames';

import styles from '../PdpSharedDetails/PdpSharedDetail.scss';

type Props = {
    dataTn: string;
    title: ReactNode;
    printHide: boolean | null;
    delimiter?: string | null;
};

export const PdpRespDetail: FC<Props> = ({ title, children, dataTn, delimiter, printHide }) => {
    const contentClasses = classnames(styles.content, { [styles.detailBlock]: !delimiter });
    const wrapperClasses = classnames(styles.wrapper, { [styles.printHide]: printHide });
    if (title && children) {
        return (
            <li className={wrapperClasses}>
                <div className={styles.title} data-tn="pdp-spec-title">
                    {title}
                </div>
                <div className={contentClasses} data-tn={`pdp-spec-${dataTn}`}>
                    {children}
                </div>
            </li>
        );
    }
    return null;
};
